export const getMockByPath = async <T>(path: string) => {
  return import(`./data/${path}.json`) as T;
};
